import { render, staticRenderFns } from "./ErrorTips.vue?vue&type=template&id=375492be&scoped=true&"
import script from "./ErrorTips.vue?vue&type=script&lang=js&"
export * from "./ErrorTips.vue?vue&type=script&lang=js&"
import style0 from "./ErrorTips.vue?vue&type=style&index=0&id=375492be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375492be",
  null
  
)

export default component.exports